import * as S from '../styles';

const RentChargeInfo = () => {
  return (
    <S.Wrapper isConnect>
      <S.Title type='page'>대여 요금 규정</S.Title>
      <S.Section type='paragraph'>
        <S.Text type='main'>
          당사의 대여 요금은 성수기/비수기, 이벤트 할인/특별 요금 할인 등 유입
          경로별, 시기별 당사의 대여 요금 정책에 따라 탄력적으로 운영하며,{' '}
          <br />
          임차인과 체결된 계약에 따라 대여 요금 및 조건이 변동될 수 있습니다.
        </S.Text>
      </S.Section>
    </S.Wrapper>
  );
};

export default RentChargeInfo;
